import React from "react"

import { ProjectPageRoomSidebar } from "./ProjectPageRoomSidebar"
import {
  UseProjectPageRoomSidebarModelArgs,
  useProjectPageRoomSidebarModel
} from "./hooks/useProjectPageRoomSidebarModel"

export const ProjectPageRoomSidebarConnector = React.memo(
  (props: UseProjectPageRoomSidebarModelArgs) => (
    <ProjectPageRoomSidebar
      autoFocus
      id="project-page-room-sidebar"
      {...useProjectPageRoomSidebarModel(props)}
    />
  )
)
